import { IMessage } from '@/context/types'

export const getAvatarText = (message: IMessage) => {
  let avatarText = 'PH'

  if (message.author.displayName) {
    const splitName = message.author.displayName.split(' ')
    if (splitName.length > 1) {
      avatarText = `${splitName[0][0]}${splitName[1][0]}`
    } else {
      avatarText = message.author.displayName.slice(0, 2)
    }
  }

  return avatarText.toUpperCase()
}

export const removeWhitespaces = (messageText: string) => {
  const splitMessageText = messageText.split('\n')

  const cleanMessageText = splitMessageText.map(line => line.trim()).join('\n')
  return cleanMessageText
}

export default { getAvatarText, removeWhitespaces }
